// extracted by mini-css-extract-plugin
export default {"container":"menuItem_container__tFzpy","title":"menuItem_title__C-pTv","notification":"menuItem_notification__xaniI","details":"menuItem_details__-ajyq"};